<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="container container10">
      <h1>Cas9 sgRNA文库构建服务</h1>
      <h2 class="mt10">Cas9 sgRNA library construction service</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">CRISPR/Cas9系统已经在基因功能研究、基因治疗药物开发、生物育种等领域中发挥了重要的作用。利用sgRNA文库，可高通量的敲除人类全基因或通路基因以及特定的基因家族，或快速的筛选出和某些疾病表型及性状相关的基因。擎科生物科提供人全基因组、特定信号通路或客户指定基因的sgRNA文库构建服务。</p>
      </div>
      <div class="container">
        <div class="c-title">服务流程<small>Service process</small></div>
        <p class="desc" style="text-indent: 0">a. 客户确定sgRNA靶点，建议每个基因设计4-5个靶点；也可提供靶基因并说明方法（CRISPRko、CRISPRa、CRISPRi），由我方设计sgRNA靶点；</p>
        <p class="desc" style="text-indent: 0">b. 若客户的靶点较少，可每个sgRNA质粒单独构建，再混合为文库；</p>
        <p class="desc" style="text-indent: 0">c. 默认使用单sgRNA慢病毒质粒，Cas9蛋白由另一慢病毒质粒单独携带；</p>
        <p class="desc" style="text-indent: 0">d. 若客户没有在文库中加入阴性、阳性对照sgRNA，我们会加入一定的对照靶点；</p>
        <p class="desc" style="text-indent: 0">e. 客户可选择sgRNA质粒文库或sgRNA慢病毒文库；</p>
      </div>
      <div class="container">
        <div class="c-title">实验流程<small>Experimental process</small></div>
        <p class="desc" style="text-indent: 0">a. 合成和扩增sgRNA；</p>
        <p class="desc" style="text-indent: 0">b. 质粒文库构建、转化大肠杆菌；</p>
        <p class="desc" style="text-indent: 0">c. 高通量测序，进行文库丰度分析和平衡性分析；</p>
        <p class="desc" style="text-indent: 0">d. 慢病毒包装（可选服务）；</p>
        <!-- <img src="@/assets/img/产品及服务/基因调控/基因编辑/Cas9sgRNA文库构建.png" class="img-fluid" style="margin-bottom: 20px;"> -->
      </div>
      <div class="container">
        <div class="c-title">服务价格<small>Product description</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="服务项目">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="服务内容">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="价格">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="周期">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus_cas9"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData: [
        {
          method1:'人全基因组sgRNA质粒文库构建',
          method2:'人全基因sgRNA文库，每个基因5个sgRNA靶点',
          method3:'询价',
          method4:'1-2周'
        },
        {
          method1:'sgRNA质粒文库',
          method2:'客户提供sgRNA或靶基因',
          method3:'评估',
          method4:'评估'
        },
        {
          method1:'人全基因组敲除慢病毒文库',
          method2:'混合包装慢病毒文库',
          method3:'询价',
          method4:'4周'
        },
        {
          method1:'人全基因组激活慢病毒文库（CRISPRa）',
          method2:'混合包装慢病毒文库',
          method3:'询价',
          method4:'4周'
        },
        {
          method1:'小鼠全基因组敲除文库',
          method2:'混合包装慢病毒文库',
          method3:'询价',
          method4:'4周'
        }
      ],
      currentType: -1,
      currentService: -1,
      types1: [
        {name: 'sgRNA合成', img: '1', ref: '/products/sgRNA_Synthesis'},
        {name: 'sgRNA质粒构建', img: '2', ref: '/products/sgRNA_plasmid_construction'},
        {name: 'CRISPRi/CRISPRa服务', img: '4', ref: '/products/CRISPRi_CRISPRa_Applications'}
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Cas9_sgRNA_library_construction.vue